<script setup lang="ts">
import {onMounted, PropType, useAttrs} from 'vue';
import {odsCard} from '../odsCard'
import {BorderRadius, Spacing} from "../../tokens";
import {Popup} from "./odsPopup"

const props = defineProps({
  options: {
    type: Object as PropType<Popup>,
    required: true
  }
})

onMounted(() => {
  setTimeout(() => {
    console.log("MOUNTED", props.options)
    props.options.setActive(true)
  }, 10)

})

const attrs = useAttrs();


function closeThatPopup() {
  if (props.options.canClose) {
    props.options.close()
  }
}

</script>

<template>
  <div class="ods-popup" :class="{active: options.isActive, 'can-close': options.canClose}">
    <div class="ods-popup-backdrop" @click.stop="closeThatPopup()"></div>
    <odsCard class="ods-popup-content"
            :id="options.id"
            :class="['ods-popup-'+options.size, `ods-popup-position-${options.position}`, options.specificClass, {'ods-popup-overflow': options.overflow}]"
            :radius="BorderRadius.XXL"
            :padding="Spacing.XXL"
    >
      <slot>
        <component :is="options.component" v-bind="options.componentProps"></component>
      </slot>
    </odsCard>
  </div>
</template>

<style lang="scss" src="./odsPopup.scss">
</style>